<script setup>
import LoadingSpinner from "@/elements/LoadingSpinner.vue";

const props = defineProps({
    loading: {
        type: Boolean,
        required: true
    }
});
</script>

<template>
    <loading-spinner class="flex items-center justify-center" v-if="loading" />

    <div v-else>
        <slot />
    </div>
</template>
